import ImgContainer from "components/common/img";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import styled from "styled-components";

const PhotoFrame = styled.div`
  width: 50px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const agencyColumns = ({ userImage, navigate, handleDeleteAction }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "",
      selector: ({ photo }) => photo,
      grow: 0,
      minWidth: "80px",
      sortable: false,
      style: { paddingTop: "0.5rem", paddingBottom: "0.5rem" },
      cell: ({ photo }) => (
        <PhotoFrame>
          <ImgContainer
            alt="cong-image"
            src={photo || userImage}
          />
        </PhotoFrame>
      ),
    },
    {
      name: "Agency",
      selector: ({ agency }) => agency,
      identifier: "agency",
      grow: 2,
      sortable: true,
      cell: ({ agency }) => <CellText>{agency}</CellText>,
    },
    {
      name: "Name",
      selector: ({ firstName }) => firstName,
      identifier: "firstName",
      grow: 3,
      sortable: true,
      cell: ({ firstName, middleName, lastName }) => (
        <CellText>{`${firstName} ${middleName || ""} ${lastName}`}</CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ phoneNumber }) => phoneNumber,
      identifier: "phoneNumber",
      grow: 2,
      sortable: true,
      cell: ({ phoneNumber }) => (
        <CellText>{getFormattedContactNumber(phoneNumber)}</CellText>
      ),
    },
    {
      name: "Cos",
      selector: ({ cosName }) => cosName,
      identifier: "cosName",
      grow: 2,
      sortable: true,
      cell: ({ cosFirstName, cosLastName, cosName }) => (
        <CellText>
          {cosFirstName && cosLastName
            ? `${cosFirstName} ${cosLastName}`
            : cosName || ""}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ cosContact }) => cosContact,
      identifier: "cosContact",
      grow: 2,
      sortable: true,
      cell: ({ cosContact }) => (
        <CellText>{getFormattedContactNumber(cosContact)}</CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row) => (
        <>
          {hasPermission("agency-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id}`}
                onClick={() => {
                  navigate("/agency/", {
                    state: { agency: row },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${row.id}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("agency-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${row.id}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${row.id}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default agencyColumns;
